<template>
  <StatusBadge
    :status="badgeStyle"
    :text="status"
  />
</template>

<script>
import {
  StatusBadge,
} from '@jumpcloud/ui-components';
import { pkiCertStatusBadgeMap } from 'client/Pki/Constants';

const defaultBadgeStyle = 'informational';

export default {
  name: 'PkiCertStatusBadge',

  components: {
    StatusBadge,
  },

  props: {
    status: {
      required: true,
      type: String,
    },
  },

  computed: {
    badgeStyle() {
      const badgeStatus = pkiCertStatusBadgeMap[this.status.toLowerCase()] || defaultBadgeStyle;
      return badgeStatus;
    },
  },

};
</script>
